var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcT2PActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11623_16576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3047 3.06055C10.5247 3.06055 8.7846 3.58839 7.30456 4.57732C5.82452 5.56625 4.67096 6.97186 3.98978 8.61639C3.30859 10.2609 3.13036 12.0705 3.47762 13.8164C3.82489 15.5622 4.68206 17.1658 5.94073 18.4245C7.1994 19.6832 8.80305 20.5403 10.5489 20.8876C12.2947 21.2349 14.1043 21.0566 15.7488 20.3755C17.3934 19.6943 18.799 18.5407 19.7879 17.0607C20.7768 15.5806 21.3047 13.8406 21.3047 12.0605C21.3022 9.67437 20.3531 7.38665 18.6659 5.69937C16.9786 4.01209 14.6909 3.06307 12.3047 3.06055ZM15.0739 14.4836C15.0739 14.5754 15.0374 14.6635 14.9725 14.7284C14.9076 14.7933 14.8196 14.8298 14.7278 14.8298H9.88161C9.78981 14.8298 9.70176 14.7933 9.63685 14.7284C9.57193 14.6635 9.53546 14.5754 9.53546 14.4836V9.63747C9.53546 9.54566 9.57193 9.45762 9.63685 9.3927C9.70176 9.32778 9.78981 9.29131 9.88161 9.29131H14.7278C14.8196 9.29131 14.9076 9.32778 14.9725 9.3927C15.0374 9.45762 15.0739 9.54566 15.0739 9.63747V14.4836Z",
    fill: "#B3B9C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11623_16576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcT2PActive);
export default __webpack_public_path__ + "static/media/ic_t2P_active.1cd68ef21242f1afb312a76203cce8df.svg";
export { ForwardRef as ReactComponent };